import { ChangeEvent } from 'react';
import { ISSUE_FILE_ACCEPT, ISSUE_FILE_HINT } from '../../utils/issueFiles';
import './IssueFilePicker.css';

type Props = {
  files: File[];
  onChange: (files: File[]) => void;
  disabled?: boolean;
  label?: string;
  accept?: string;
  hint?: string;
};

const IssueFilePicker = ({
  files,
  onChange,
  disabled = false,
  label = 'Файлы',
  accept = ISSUE_FILE_ACCEPT,
  hint = ISSUE_FILE_HINT,
}: Props) => {
  const handlePick = (event: ChangeEvent<HTMLInputElement>) => {
    const picked = Array.from(event.target.files || []);
    event.target.value = '';
    if (picked.length === 0) return;
    onChange([...files, ...picked]);
  };

  return (
    <div className="issue-file-picker">
      <label>{label}</label>
      <p className="issue-file-hint">{hint}</p>
      <label className="issue-file-attach">
        Прикрепить
        <input
          type="file"
          accept={accept}
          multiple
          disabled={disabled}
          onChange={handlePick}
          hidden
        />
      </label>
      {files.length > 0 ? (
        <ul className="issue-file-pending">
          {files.map((file, index) => (
            <li key={`${file.name}-${file.size}-${index}`}>
              <span>{file.name}</span>
              <button
                type="button"
                className="issue-file-remove"
                onClick={() =>
                  onChange(files.filter((_, itemIndex) => itemIndex !== index))
                }
                disabled={disabled}
              >
                Убрать
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
};

export default IssueFilePicker;
